import { memo } from 'react';
import { FormattedMessage, FormattedRelativeTime } from 'react-intl';

import { Tag, TYPOGRAPHY_VARIANTS, Typography } from '@didaskill/ui/design-system';
import { getUnit } from '@didaskill/utils/misc';

import { useCountdown } from '../../../hooks/useCountdown';
import messages from './QuestDialog.messages';
import * as styles from './QuestDialog.styles';

const RemainingTimeBase = ({ endOfQuest }: { endOfQuest: Date }) => {
  const { unit } = getUnit(endOfQuest);

  const remainingSeconds = useCountdown({
    date: endOfQuest.toISOString(),
    unit,
    interval: 1000,
  });

  if (unit === 'second' && remainingSeconds <= 0) {
    return null;
  }

  return (
    <div css={styles.remainingTimeContainer}>
      <Typography variant={TYPOGRAPHY_VARIANTS.BODY_SMALL_BOLD} css={styles.remainingTime}>
        <FormattedMessage {...messages.REMAINING_TIME} />
      </Typography>
      <Tag label={<FormattedRelativeTime value={remainingSeconds} unit={unit} />} />
    </div>
  );
};

RemainingTimeBase.displayName = 'RemainingTime';

export const RemainingTime = memo(RemainingTimeBase);
